'use strict';

var _ = require('lodash');
var SystemStatusServiceSentController = function SystemStatusServiceSentController($scope, systemStatusFlightRenderersFactory, systemStatusCommonRendererFactory) {
  $scope.customRenderers = _.assign({}, systemStatusFlightRenderersFactory, systemStatusCommonRendererFactory);
};
SystemStatusServiceSentController.$inject = ['$scope', 'SystemStatusFlightRenderersFactory', 'SystemStatusCommonRendererFactory', 'ConfigurationService'];
module.exports = SystemStatusServiceSentController;